global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;
$(function() {
	//Utility functions
	function getScreenSize() {
		const width =
			window.innerWidth ||
			document.documentElement.clientWidth ||
			document.body.clientWidth;
		const height =
			window.innerHeight ||
			document.documentElement.clientHeight ||
			document.body.clientHeight;
		return { width, height };
	}

	function progressBarHandler(carousel, progressBar, nextBtn, prevBtn) {
		var count = parseInt(carousel?.dataset.elementCount || '1') - 1;
		var current = parseInt(carousel?.dataset.elementCurrent || '0');
		if (count > 0) progressBar.style.width = (current / count) * 100 + '%';
		else if (count == 0) {
			progressBar.style.width = '100%';
		} else {
			progressBar.style.width = '0%';
		}

		const screenSize = getScreenSize();
		if (screenSize.width > 768) {
			if (current < count) {
				nextBtn.removeAttribute('aria-hidden');
				nextBtn.classList.remove('visually-hidden');
				nextBtn.disabled = false;
				nextBtn.style.display = 'block';
			} else {
				nextBtn.classList.add('visually-hidden');
				nextBtn.setAttribute('aria-hidden', true);
				nextBtn.disabled = true;
				nextBtn.style.display = 'none';
			}
			if (current > 0) {
				prevBtn.removeAttribute('aria-hidden');
				prevBtn.classList.remove('visually-hidden');
				prevBtn.disabled = false;
				nextBtn.style.display = 'block';
			} else {
				prevBtn.classList.add('visually-hidden');
				prevBtn.setAttribute('aria-hidden', true);
				prevBtn.disabled = true;
				nextBtn.style.display = 'none';
			}
		} else {
			if (!nextBtn.classList.contains('visually-hidden'))
				nextBtn.classList.add('visually-hidden');
			if (!prevBtn.classList.contains('visually-hidden'))
				prevBtn.classList.add('visually-hidden');
		}
	}

	function disableTabHiddenElements() {
		// Select all elements with the visually-hidden class
		const visuallyHiddenElements = document.querySelectorAll(
			'.visually-hidden a'
		);

		// Loop through each element and add the tabindex attribute
		visuallyHiddenElements.forEach(element => {
			element.setAttribute('tabindex', '-1');
		});

		// Select all elements with the visually-hidden class
		const visibleElements = document.querySelectorAll('.carousel-item a');
		// Loop through each element and add the tabindex attribute
		visibleElements.forEach(element => {
			element.removeAttribute('tabindex');
		});
	}

	function generateDesktopItems() {
		var mobileItems = document.getElementsByClassName(
			'js-item-responsive js-events_carousel'
		);
		var desktopItems = document.getElementsByClassName(
			'carousel-inner js-events_carousel'
		);
		var divItem = document.createElement('div');
		divItem.classList.add(
			'desktop-only',
			'visually-hidden',
			'events_slide'
		);
		var rowItem = document.createElement('div');

		rowItem.classList.add('row');

		for (let i = 0; i < mobileItems.length; i++) {
			var elementCloned = mobileItems[i].cloneNode(true);
			elementCloned.classList.remove('col-12');
			elementCloned.classList.remove('js-item-responsive');
			elementCloned.classList.add('col-4');
			rowItem.appendChild(elementCloned);
			if ((i + 1) % 3 == 0 || i + 1 == mobileItems.length) {
				divItem.appendChild(rowItem.cloneNode(true));
				desktopItems[0].appendChild(divItem.cloneNode(true));
				divItem = document.createElement('div');
				divItem.classList.add(
					'desktop-only',
					'visually-hidden',
					'events_slide'
				);
				rowItem = document.createElement('div');
				rowItem.classList.add('row');
			}
		}
	}

	function init_events_carousel() {
		//Declare variables
		var carousel = document.getElementById('events_carousel');
		const nextBtn = document.getElementById('slider-events-next');
		const prevBtn = document.getElementById('slider-events-prev');
		const progressBar = document.getElementById('events-progressbar');
		var slidesM = document.getElementsByClassName(
			'mobile-only events_slide'
		);
		var mobileIndex = 0;
		var mobileStartX = 0;
		var mobileDragging = false;
		if (carousel) {
			$('#events_carousel').carousel({ wrap: false });
			var mobileTrack = carousel.querySelector(
				'.carousel-inner.js-events_carousel'
			);

			function getMobileStep() {
				if (!slidesM.length) return 0;
				var styles = window.getComputedStyle(slidesM[0]);
				var marginRight = parseFloat(styles.marginRight || '0');
				return slidesM[0].getBoundingClientRect().width + marginRight;
			}

			function updateMobileTrack() {
				if (!mobileTrack) return;
				var step = getMobileStep();
				if (step <= 0) return;
				var maxIndex = slidesM.length - 1;
				if (mobileIndex > maxIndex) mobileIndex = maxIndex;
				if (mobileIndex < 0) mobileIndex = 0;
				mobileTrack.style.transform =
					'translateX(' + -(mobileIndex * step) + 'px)';
				carousel.dataset.elementCurrent = mobileIndex;
				carousel.dataset.elementCount = slidesM.length;
				progressBarHandler(carousel, progressBar, nextBtn, prevBtn);
			}

			function slideMobilePrev() {
				mobileIndex = mobileIndex - 1;
				updateMobileTrack();
			}

			function slideMobileNext() {
				mobileIndex = mobileIndex + 1;
				updateMobileTrack();
			}

			function handleMobileTouchStart(event) {
				mobileDragging = true;
				mobileStartX = event.touches[0].clientX;
			}

			function handleMobileTouchMove(event) {
				if (!mobileDragging) return;
				var currentX = event.touches[0].clientX;
				var diffX = currentX - mobileStartX;
				if (diffX > 0) {
					slideMobilePrev();
				} else if (diffX < 0) {
					slideMobileNext();
				}
				mobileDragging = false;
			}

			function initMobileTrack() {
				if (carousel.dataset.mobileTrackInit === 'true') return;
				carousel.dataset.mobileTrackInit = 'true';
				carousel.addEventListener('touchstart', handleMobileTouchStart);
				carousel.addEventListener('touchmove', handleMobileTouchMove);
				updateMobileTrack();
			}
			//Listener Events
			window.addEventListener('resize', function() {
				const screenSize = getScreenSize();
				carousel.dataset.elementCurrent = 0;
				var slidesD = document.getElementsByClassName(
					'desktop-only events_slide'
				);
				if (screenSize.width <= 768) {
					carousel.dataset.elementCount = slidesM.length;
					initMobileTrack();
					if (!nextBtn.classList.contains('visually-hidden'))
						nextBtn.classList.add('visually-hidden');
					if (!prevBtn.classList.contains('visually-hidden'))
						prevBtn.classList.add('visually-hidden');
					for (let i = 0; i < slidesM.length; i++) {
						slidesM[i].classList.remove('active');
						if (!slidesM[i].classList.contains('carousel-item')) {
							slidesM[i].classList.add('carousel-item');
						}
						if (slidesM[i].classList.contains('visually-hidden')) {
							slidesM[i].classList.remove('visually-hidden');
						}
						if (
							i == 0 &&
							!slidesM[i].classList.contains('active')
						) {
							slidesM[i].classList.add('active');
						}
					}
					for (let i = 0; i < slidesD.length; i++) {
						slidesD[i].classList.remove('active');
						if (slidesD[i].classList.contains('carousel-item')) {
							slidesD[i].classList.remove('carousel-item');
						}
						if (!slidesD[i].classList.contains('visually-hidden')) {
							slidesD[i].classList.add('visually-hidden');
						}
						if (slidesD[i].classList.contains('active')) {
							slidesD[i].classList.remove('active');
						}
					}
					updateMobileTrack();
				} else {
					carousel.dataset.elementCount = slidesD.length;
					if (nextBtn.classList.contains('visually-hidden'))
						nextBtn.classList.remove('visually-hidden');
					if (prevBtn.classList.contains('visually-hidden'))
						prevBtn.classList.remove('visually-hidden');
					for (let i = 0; i < slidesM.length; i++) {
						slidesM[i].classList.remove('active');
						if (slidesM[i].classList.contains('carousel-item')) {
							slidesM[i].classList.remove('carousel-item');
						}
						if (!slidesM[i].classList.contains('visually-hidden')) {
							slidesM[i].classList.add('visually-hidden');
							slidesM[i].setAttribute('varia-hidden', true);
						}
						if (slidesM[i].classList.contains('active')) {
							slidesM[i].classList.remove('active');
						}
					}
					for (let i = 0; i < slidesD.length; i++) {
						slidesD[i].classList.remove('active');
						if (!slidesD[i].classList.contains('carousel-item')) {
							slidesD[i].classList.add('carousel-item');
						}
						if (slidesD[i].classList.contains('visually-hidden')) {
							slidesD[i].classList.remove('visually-hidden');
						}
						if (
							i == 0 &&
							!slidesD[i].classList.contains('active')
						) {
							slidesD[i].classList.add('active');
						}
					}
				}
				progressBarHandler(carousel, progressBar, nextBtn, prevBtn);
				disableTabHiddenElements();
			});

			carousel.addEventListener('slide.bs.carousel', function(data) {
				carousel.dataset.elementCurrent = data.to;
				progressBarHandler(carousel, progressBar, nextBtn, prevBtn);
			});

			//Carousel initialization
			const screenSize = getScreenSize();
			carousel.dataset.elementCurrent = 0;

			if (screenSize.width <= 768) {
				carousel.dataset.elementCount = slidesM.length;
				generateDesktopItems();
				initMobileTrack();
				if (!nextBtn.classList.contains('visually-hidden'))
					nextBtn.classList.add('visually-hidden');
				if (!prevBtn.classList.contains('visually-hidden'))
					prevBtn.classList.add('visually-hidden');
				for (let i = 0; i < slidesM.length; i++) {
					if (!slidesM[i].classList.contains('carousel-item')) {
						slidesM[i].classList.add('carousel-item');
					}
					if (slidesM[i].classList.contains('visually-hidden')) {
						slidesM[i].classList.remove('visually-hidden');
					}
					if (i == 0 && !slidesM[i].classList.contains('active')) {
						slidesM[i].classList.add('active');
					}
				}
				updateMobileTrack();
			} else {
				generateDesktopItems();

				if (nextBtn.classList.contains('visually-hidden'))
					nextBtn.classList.remove('visually-hidden');
				if (prevBtn.classList.contains('visually-hidden'))
					prevBtn.classList.remove('visually-hidden');

				var slidesD = document.getElementsByClassName(
					'desktop-only events_slide'
				);
				carousel.dataset.elementCount = slidesD.length;

				for (let i = 0; i < slidesD.length; i++) {
					if (!slidesD[i].classList.contains('carousel-item')) {
						slidesD[i].classList.add('carousel-item');
					}
					if (slidesD[i].classList.contains('visually-hidden')) {
						slidesD[i].classList.remove('visually-hidden');
					}
					if (i == 0 && !slidesD[i].classList.contains('active')) {
						slidesD[i].classList.add('active');
					}
				}
			}
			progressBarHandler(carousel, progressBar, nextBtn, prevBtn);
			disableTabHiddenElements();
		}
	}

	init_events_carousel();
});
